<!-- ════════════════════════════════════════════
     LOADING STATE — Skeleton
════════════════════════════════════════════ -->
@if (loading()) {
<div class="detail-skeleton">
  <div class="skeleton-header">
    <div class="sk sk--breadcrumb"></div>
    <div class="sk sk--title"></div>
    <div class="sk sk--subtitle"></div>
    <div class="sk sk--actions"></div>
  </div>
  <div class="skeleton-body">
    <div class="sk sk--image"></div>
    <div class="skeleton-tabs">
      <div class="sk sk--tab-bar"></div>
      <div class="sk sk--table-row"></div>
      <div class="sk sk--table-row"></div>
      <div class="sk sk--table-row"></div>
    </div>
  </div>
</div>
}

<!-- ════════════════════════════════════════════
     ERROR STATE
════════════════════════════════════════════ -->
@else if (error()) {
<div class="error-wrap">
  <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
  <h2>{{ 'indexDetails.errorLoading' | translate }}</h2>
  <p>{{ error() | translate }}</p>
  <a routerLink="/browse-index" class="btn-back">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <polyline points="15 18 9 12 15 6" />
    </svg>
    {{ 'indexDetails.backToIndex' | translate }}
  </a>
</div>
}

<!-- ════════════════════════════════════════════
     MAIN RECORD
════════════════════════════════════════════ -->
@else if (biblio(); as b) {
  
  <!-- ── Breadcrumb bar ── -->
  
  <app-bread-crump [description]="b.subtitle?b.subtitle:''"
    [items]="[{label: 'indexDetails.home' | translate, url: '/home'}, {label: 'Nav.biblios' | translate, url: '/browse-index'}, {label: b.title, url: ''}]"
    [title]="b.title"></app-bread-crump>
  <div class="container">
  <!-- <nav class="breadcrumb-bar" aria-label="مسار التنقل">
      <a routerLink="/home" class="bc-link">الرئيسية</a>
      <span class="bc-sep">›</span>
      <a routerLink="/browse-index" class="bc-link">فهرس المكتبة</a>
      <span class="bc-sep">›</span>
      <span class="bc-current">{{ b.title }}</span>
    </nav> -->

  <!-- ── Title block ── -->
  <!-- ── Body: Views ── -->
  <div class="record-body">
  
  <div class="row">
    <!-- Sidebar Actions -->
    <div class="col-lg-3 mb-4 mb-lg-0">
      <div class="record-sidebar bg-white rounded shadow-sm p-3 h-100">
        @if (holdError()) {
          <div class="alert alert-danger p-2 fs-7 mb-3">{{ holdError() }}</div>
        }
        @if (holdSuccess()) {
          <div class="alert alert-success p-2 fs-7 mb-3">{{ holdSuccess() }}</div>
        }
        <ul class="nav flex-column action-list ps-0" style="padding-inline-start: 0;">
          <li class="nav-item">
            @if (currentHoldId()) {
              <button class="nav-link w-100 d-flex align-items-center justify-content-start text-start gap-2 action-btn text-danger" (click)="removeHold()" [disabled]="isHolding()">
                @if (isHolding()) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                } @else {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path><line x1="3" y1="3" x2="21" y2="21"></line></svg>
                }
                <span>{{ 'indexDetails.removeHold' | translate: { default: 'إلغاء الحجز' } }}</span>
              </button>
            } @else {
              <button class="nav-link w-100 d-flex align-items-center justify-content-start text-start gap-2 action-btn" (click)="placeHold()" [disabled]="isHolding()">
                @if (isHolding()) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                } @else {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>
                }
                <span>{{ 'indexDetails.placeHold' | translate: { default: 'احجز' } }}</span>
              </button>
            }
          </li>
          <li class="nav-item">
            <button class="nav-link w-100 d-flex align-items-center justify-content-start text-start gap-2 action-btn" (click)="printRecord()">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
              <span>{{ 'indexDetails.print' | translate: { default: 'طباعة' } }}</span>
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link w-100 d-flex align-items-center justify-content-start text-start gap-2 action-btn" (click)="citeRecord()">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
              </svg>
              <span>{{ 'indexDetails.cite' | translate: { default: 'استشهاد' } }}</span>
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link w-100 d-flex align-items-center justify-content-start text-start gap-2 action-btn" (click)="suggestPurchase()">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>
              <span>{{ 'indexDetails.suggestPurchase' | translate: { default: 'اقترح للشراء' } }}</span>
            </button>
          </li>
          <li class="nav-item position-relative">
            <button class="nav-link w-100 d-flex align-items-center justify-content-start text-start gap-2 action-btn" (click)="toggleSaveDropdown($event)">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
              <span>{{ 'indexDetails.saveRecord' | translate: { default: 'حفظ التسجيلة' } }}</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ms-auto" [style.transform]="showSaveDropdown() ? 'rotate(180deg)' : 'none'" style="transition: transform 0.2s;"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </button>

            @if (showSaveDropdown()) {
              <div class="save-dropdown-menu shadow-lg bg-white rounded border py-2 mt-1 position-absolute w-100" style="z-index: 1000;" (click)="$event.stopPropagation()">
                <button type="button" class="dropdown-item d-flex align-items-center gap-2 px-3 py-2 text-dark border-0 bg-transparent w-100 text-start" (click)="exportBibTeX()">
                  <span class="badge bg-light text-dark border font-monospace">.bib</span>
                  <span>BibTeX</span>
                </button>
                <button type="button" class="dropdown-item d-flex align-items-center gap-2 px-3 py-2 text-dark border-0 bg-transparent w-100 text-start" (click)="exportRIS()">
                  <span class="badge bg-light text-dark border font-monospace">.ris</span>
                  <span>RIS (EndNote, Zotero)</span>
                </button>
                <button type="button" class="dropdown-item d-flex align-items-center gap-2 px-3 py-2 text-dark border-0 bg-transparent w-100 text-start" (click)="exportText()">
                  <span class="badge bg-light text-dark border font-monospace">.txt</span>
                  <span>نص عادي (ISBD)</span>
                </button>
                <button type="button" class="dropdown-item d-flex align-items-center gap-2 px-3 py-2 text-dark border-0 bg-transparent w-100 text-start" (click)="exportMarcJson()">
                  <span class="badge bg-light text-dark border font-monospace">.json</span>
                  <span>MARC-in-JSON</span>
                </button>
              </div>
            }
          </li>
          <li class="nav-item">
          </li>
        </ul>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="col-lg-9">
      <!-- Tab area -->
      <section class="record-tabs-area">

        <!-- Tab navigation -->
        <nav class="tab-nav" role="tablist" style="margin-bottom: 2rem;">
      @for (tab of tabs; track tab.key) {
      <button class="tab-btn" [class.tab-btn--active]="activeTab() === tab.key" (click)="setTab(tab.key)" role="tab"
        style="display: inline-flex; align-items: center; gap: 0.5rem;"
        [attr.aria-selected]="activeTab() === tab.key" [id]="'tab-' + tab.key"
        [attr.aria-controls]="'panel-' + tab.key">
        @if (tab.icon === 'book') {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 18px; height: 18px;">
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        </svg>
        }

        @if (tab.icon === 'copies') {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 18px; height: 18px;">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
        </svg>
        }
        @if (tab.icon === 'marc') {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 18px; height: 18px;">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
        }

        {{ tab.label | translate }}
      </button>
      }
    </nav>

    <!-- ┌─ Panel: المقتنيات — Holdings ─┐ -->
    @if (activeTab() === 'book') {
    <div class="tab-panel" id="panel-book" role="tabpanel">
      @if (b.holdings.length === 0) {
      <div class="empty-panel">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        </svg>
        <p>{{ 'indexDetails.noHoldings' | translate }}</p>
      </div>
      } @else {
      <div class="table-scroll">
        <table class="holdings-tbl">
          <thead>
            <tr>
              <th>{{ 'Nav.barcode' | translate }}</th>
              <th>{{ 'indexDetails.resourceType' | translate }}</th>
              <th>{{ 'indexDetails.status' | translate }}</th>
              <th>{{ 'indexDetails.currentLibrary' | translate }}</th>
              <th>{{ 'indexDetails.publicationDate' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (h of b.holdings; track h.itemId) {
            <tr>
              <td class="td-mono"><span dir="ltr">{{ h.barcode || h.externalId || '—' }}</span></td>
              <td>{{ 'indexDetails.book' | translate }}</td>
              <td>
                <span class="status-chip status-chip--{{ h.status }}">
                  {{ statusLabel(h.status) | translate }}
                </span>
              </td>
              <td>{{ h.homeLibraryName ?? h.homeLibraryId }}</td>
              <td class="td-mono">
                @if (h.acquisitionDate) {
                {{ h.acquisitionDate | date:'dd/MM/yyyy' }}
                } @else {
                —
                }
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      }
    </div>
    }



    <!-- ┌─ Panel: الاستنساخات — Copies ─┐ -->
    <!-- @if (activeTab() === 'copies') {
    <div class="tab-panel" id="panel-copies" role="tabpanel">
      @if (b.holdings.length === 0) {
      <div class="empty-panel">
        <p>{{ 'indexDetails.noCopies' | translate }}</p>
      </div>
      } @else {
      <div class="copies-grid">
        @for (h of b.holdings; track h.itemId) {
        <div class="copy-card">
          <div class="copy-card__top">
            <span class="copy-id"># {{ h.itemId }}</span>
            <span class="status-chip status-chip--{{ h.status }}">{{ statusLabel(h.status) | translate }}</span>
          </div>
          <dl class="copy-dl">
            @if (h.homeLibraryName) {
            <div>
              <dt>{{ 'indexDetails.library' | translate }}</dt>
              <dd>{{ h.homeLibraryName }}</dd>
            </div>
            }
            @if (h.collectionCode) {
            <div>
              <dt>{{ 'indexDetails.category' | translate }}</dt>
              <dd>{{ h.collectionCode }}</dd>
            </div>
            }
            @if (h.callNumber) {
            <div>
              <dt>{{ 'indexDetails.callNumber' | translate }}</dt>
              <dd dir="ltr">{{ h.callNumber }}</dd>
            </div>
            }
            @if (h.publicNotes) {
            <div>
              <dt>{{ 'indexDetails.note' | translate }}</dt>
              <dd>{{ h.publicNotes }}</dd>
            </div>
            }
          </dl>
        </div>
        }
      </div>
      }
    </div>
    } -->

    <!-- ┌─ Panel: MARC ─┐ -->
    @if (activeTab() === 'marc') {
    <div class="tab-panel" id="panel-marc" role="tabpanel">
      @if (!b.marcFields || b.marcFields.length === 0) {
      <div class="empty-panel">
        <p>{{ 'indexDetails.placeholderText' | translate }}</p>
      </div>
      } @else {
      <div class="marc-view-container">
        @for (field of b.marcFields; track field.tag) {
        <div class="marc-field">
          <div class="marc-field-header">
            <span>
              <strong>{{ field.tag }}</strong> 
              <span class="marc-indicators">{{ field.ind1 || '#' }}{{ field.ind2 || '#' }}</span> 
              - {{ 'marcTags.' + field.tag | translate }}
            </span>
          </div>
          <div class="marc-subfields">
            @if (field.value) {
            <div class="marc-subfield-row">
              <div class="marc-subfield-label">{{ 'marcSubfields.fixed' | translate }}</div>
              <div class="marc-subfield-value">{{ field.value }}</div>
            </div>
            } @else {
              @for (sub of field.subfields; track sub.code) {
              <div class="marc-subfield-row">
                <div class="marc-subfield-label">
                  @if (('marcSubfields.' + field.tag + sub.code | translate); as translated) {
                    {{ translated === 'marcSubfields.' + field.tag + sub.code ? sub.code : translated }}
                  }
                </div>
                <div class="marc-subfield-value">{{ sub.value }}</div>
              </div>
              }
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
    }



  </section>
    </div> <!-- /col-lg-9 -->

  </div> <!-- /row -->

</div>
<!-- /record-body -->
<!-- /record-body -->

</div>

<!-- Cite Modal -->
@if (showCiteModal()) {
<div class="custom-modal-overlay" (click)="showCiteModal.set(false)">
  <div class="custom-modal-dialog" (click)="$event.stopPropagation()">
    <div class="custom-modal-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0"><span dir="auto">{{ biblio()?.title }}</span> : {{ 'indexDetails.tabs.isbd' | translate: { default: 'الفهرست' } }}</h5>
      <button class="btn-close-custom" (click)="showCiteModal.set(false)">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="custom-modal-body">
      @for (c of citations(); track c.style) {
        <div class="mb-4 text-start">
          <h6 class="fw-bold text-muted mb-2 fs-5">{{ c.style }}</h6>
          <p class="fs-6" dir="auto">{{ c.text }}</p>
        </div>
      }
    </div>
    <div class="custom-modal-footer text-start">
      <button class="btn btn-light border px-4 py-2" (click)="showCiteModal.set(false)">إغلاق</button>
    </div>
  </div>
</div>
}

<!-- Suggestion Modal -->
@if (showSuggestModal()) {
<div class="custom-modal-overlay" (click)="closeSuggestModal()">
  <div class="custom-modal-dialog" (click)="$event.stopPropagation()">
    
    <div class="custom-modal-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0 fw-bold">{{ 'suggestion.title' | translate }}</h5>
      <button class="btn-close-custom" (click)="closeSuggestModal()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>

    <div class="custom-modal-body">
      @if (!getPatronId()) {
        <div class="text-center py-4">
          <div class="mb-3 text-warning">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <h5 class="fw-bold mb-2">{{ 'suggestion.loginRequired' | translate }}</h5>
          <p class="text-muted">{{ 'Nav.loginError.required' | translate }}</p>
        </div>
      } @else if (suggestSuccess()) {
        <div class="text-center py-4">
          <div class="mb-3 text-success">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h5 class="fw-bold text-success mb-2">{{ 'suggestion.successTitle' | translate }}</h5>
          <p class="text-muted">{{ 'suggestion.successDesc' | translate }}</p>
        </div>
      } @else {
        @if (suggestError()) {
          <div class="alert alert-danger py-2 mb-3">{{ suggestError() }}</div>
        }

        <form (ngSubmit)="submitSuggestion()">
          <div class="mb-3">
            <label class="form-label fw-bold small text-muted">{{ 'suggestion.bookTitle' | translate }} <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="suggestTitle" name="suggestTitle"
              [placeholder]="'suggestion.bookTitle' | translate" required>
          </div>

          <div class="mb-3">
            <label class="form-label fw-bold small text-muted">{{ 'suggestion.author' | translate }}</label>
            <input type="text" class="form-control" [(ngModel)]="suggestAuthor" name="suggestAuthor"
              [placeholder]="'suggestion.author' | translate">
          </div>

          <div class="mb-3">
            <label class="form-label fw-bold small text-muted">{{ 'suggestion.library' | translate }}</label>
            <input type="text" class="form-control bg-light" [value]="'suggestion.defaultLibrary' | translate" readonly>
          </div>

          <div class="mb-3">
            <label class="form-label fw-bold small text-muted">{{ 'suggestion.note' | translate }}</label>
            <textarea class="form-control" rows="3" [(ngModel)]="suggestNote" name="suggestNote"
              [placeholder]="'suggestion.notePlaceholder' | translate"></textarea>
          </div>
        </form>
      }
    </div>

    <div class="custom-modal-footer d-flex justify-content-between align-items-center">
      @if (!getPatronId() || suggestSuccess()) {
        <button type="button" class="btn btn-secondary px-4 ms-auto" (click)="closeSuggestModal()">
          {{ 'suggestion.close' | translate }}
        </button>
      } @else {
        <button type="button" class="btn btn-light border px-4" (click)="closeSuggestModal()" [disabled]="isSuggesting()">
          {{ 'suggestion.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="submitSuggestion()" [disabled]="isSuggesting()">
          @if (isSuggesting()) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span>{{ 'suggestion.submitting' | translate }}</span>
          } @else {
            <span>{{ 'suggestion.submit' | translate }}</span>
          }
        </button>
      }
    </div>

  </div>
</div>
}

}